import AspectRatioContainer from 'components/about-us/AspectRatioContainer';
import { useMonthlyRaffleData } from 'hooks/draw/useMonthlyRaffleData';
import { useUserStore } from 'hooks/stores/useUserStore';
import Link from 'next/link';
import { formatShortDate, getMonthName } from 'utils/draw/getMonthName';
import styles from './DashboardMonthlyGiveaway.module.css';
import { CurrentUserProgressionBar } from './ProgressionBar';
import { Monthly10k } from '@daymade/common-lib/constants';

interface Props {}
const DashboardProgressionBar = (props: Props) => {
  const userStore = useUserStore();
  const { monthlyRaffleData } = useMonthlyRaffleData();

  if (!userStore.isInMonthlyRaffle || !monthlyRaffleData) {
    return null;
  }

  return (
    <div className={`aboutUsTypographyReset ${styles.outerContainer}`}>
      <h2 className={styles.plasmicDashboardHeading}>Monthly £10K giveaway</h2>
      <p className={styles.plasmicDashboardSubheading}>
        Bonus raffle for Premium & Lite players
      </p>
      <div className={styles.container}>
        <CurrentUserProgressionBar />
        <div className={styles.prizeInfo}>
          <div className={styles.prizeTextContainer}>
            <div className="aboutUsTypographyBodySmall">
              {getMonthName(monthlyRaffleData.drawDate)} Prize
            </div>
            {monthlyRaffleData?.prize && (
              <div
                className={`aboutUsTypographyHeaderMedium ${styles.prizeTitle}`}
              >
                {monthlyRaffleData.prize.title}
              </div>
            )}
            {monthlyRaffleData.drawDate && (
              <div
                className={`${styles.drawDateBadge} aboutUsTypographyCaption`}
              >
                Draw date: {formatShortDate(monthlyRaffleData.drawDate)}
              </div>
            )}
          </div>
          {monthlyRaffleData.prize && (
            <div className={styles.prizeImageContainer}>
              <AspectRatioContainer width={127} height={123}>
                <img
                  src={monthlyRaffleData.prize.imageLocations.main}
                  alt={monthlyRaffleData.prize.seoImageAltText.main}
                />
              </AspectRatioContainer>
            </div>
          )}
          <Link href={Monthly10k.urlPath}>
            <a className={styles.fillContainer} />
          </Link>
        </div>
      </div>
      <div className={styles.footer}>
        <Link href={Monthly10k.urlPath}>
          <a>Learn more</a>
        </Link>
      </div>
    </div>
  );
};

export default DashboardProgressionBar;
